import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../auth/authConfig";
import type { ReactNode } from "react";
import { useEffect, useRef } from "react";
import { isE2EMode } from "../auth/e2eMode";

interface AuthenticatedRouteProps {
    children: ReactNode;
}

export function AuthenticatedRoute({ children }: AuthenticatedRouteProps) {
    // In E2E mode, skip all auth checks
    if (isE2EMode()) {
        return <>{children}</>;
    }

    return <AuthenticatedRouteInner>{children}</AuthenticatedRouteInner>;
}

function AuthenticatedRouteInner({ children }: AuthenticatedRouteProps) {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const hasTriggeredLogin = useRef(false);

    useEffect(() => {
        if (inProgress === InteractionStatus.None && !isAuthenticated && !hasTriggeredLogin.current) {
            hasTriggeredLogin.current = true;
            instance.loginRedirect(loginRequest).catch(error => {
                console.error("Login redirect failed:", error);
                hasTriggeredLogin.current = false; // Reset on error to allow retry
            });
        }
    }, [inProgress, isAuthenticated, instance]);

    if (inProgress !== InteractionStatus.None) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <div>Redirecting to login...</div>;
    }

    return <>{children}</>;
}
